import React from "react";

const AIIcon = ({width=`26`,height=`24`}) => {
  return (
    <div>
      <svg
        width={width}
        height={height}
        viewBox="0 0 26 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C13.43 22 14.8 21.7 16.03 21.15"
          stroke="#292D32"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.178 12.755H10.214L10.335 13.514H7.057L7.178 12.755ZM8.575 8.707L8.784 8.861L6.859 14.966C6.859 15.01 6.892 15.0503 6.958 15.087C7.024 15.1237 7.11933 15.153 7.244 15.175C7.36867 15.197 7.51533 15.208 7.684 15.208H7.794V16H5.22V15.208H5.275C5.473 15.208 5.63433 15.1677 5.759 15.087C5.891 14.999 5.99733 14.823 6.078 14.559L8.146 8.113H10.038L12.139 14.603C12.2197 14.845 12.3223 15.0063 12.447 15.087C12.579 15.1677 12.7403 15.208 12.931 15.208H12.997V16H9.631V15.208H9.752C9.92067 15.208 10.0673 15.2043 10.192 15.197C10.3167 15.1823 10.412 15.1677 10.478 15.153C10.544 15.131 10.577 15.109 10.577 15.087L8.575 8.707ZM14.681 14.812V9.378C14.681 9.21667 14.6077 9.11033 14.461 9.059C14.3217 9.00767 14.1384 8.982 13.911 8.982H13.724V8.19H17.321V8.982H17.134C16.9067 8.982 16.7197 9.00767 16.573 9.059C16.4337 9.11033 16.364 9.21667 16.364 9.378V14.812C16.364 14.9733 16.4337 15.0797 16.573 15.131C16.7197 15.1823 16.9067 15.208 17.134 15.208H17.321V16H13.724V15.208H13.911C14.1384 15.208 14.3217 15.1823 14.461 15.131C14.6077 15.0797 14.681 14.9733 14.681 14.812Z"
          fill="black"
        />
        <g clipPath="url(#clip0_46_3766)">
          <path
            d="M19.5 21.3334V19.6667M19.5 16.3334V14.6667M18.6667 15.5H20.3334M18.6667 20.5H20.3334M22.3334 15L21.7553 16.503C21.6613 16.7474 21.6143 16.8696 21.5412 16.9724C21.4764 17.0635 21.3968 17.1431 21.3057 17.2079C21.2029 17.281 21.0807 17.328 20.8363 17.422L19.3334 18L20.8363 18.5781C21.0807 18.6721 21.2029 18.7191 21.3057 18.7922C21.3968 18.857 21.4764 18.9366 21.5412 19.0277C21.6143 19.1305 21.6613 19.2527 21.7553 19.4971L22.3334 21L22.9114 19.4971C23.0054 19.2527 23.0524 19.1305 23.1255 19.0277C23.1903 18.9366 23.2699 18.857 23.361 18.7922C23.4638 18.7191 23.586 18.6721 23.8304 18.5781L25.3334 18L23.8304 17.422C23.586 17.328 23.4638 17.281 23.361 17.2079C23.2699 17.1431 23.1903 17.0635 23.1255 16.9724C23.0524 16.8696 23.0054 16.7474 22.9114 16.503L22.3334 15Z"
            stroke="black"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_46_3766">
            <rect
              width="8"
              height="8"
              fill="white"
              transform="translate(18 14)"
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
};

export default AIIcon;
